const SB_TABLET_APP_USER_AGENT = 'SBTabletApp';

export function isTabletApp() {
  return navigator.userAgent.includes(SB_TABLET_APP_USER_AGENT);
}
